// React
import React, { useState, useEffect } from 'react';

// Material UI
import { TextField, Button, Stack, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

// react router dom
import { Link, useNavigate } from "react-router-dom";

import LoadingComponent from "./LoadingComponent";

// Firebase
import { useAuthState } from "react-firebase-hooks/auth";
import {
  auth,
  signupWithEmailAndPassword,
  signInWithGoogle,
  createUserWithEmailAndPassword
} from "../firebase";

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  const register = (e) => {
    e.preventDefault();
    signupWithEmailAndPassword(email,password);
  }

  useEffect(()=>{
    if(loading){
      return ;
    }
    if(user){
      navigate("/home");
      return;
    }
  },[loading,user]);

  return (

    !user && !loading ?

    <div className="content">
      <form className="Login" onSubmit={register}>
        <h1>Sign-Up</h1>
        <Stack spacing={2}>
          <TextField
            label="Email"
            variant="outlined"
            type="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <Button type="submit" variant="contained" color="success">
              SignUp
          </Button>
        </Stack>
      </form>
      <Stack spacing={2} className="options">
        <Button variant="contained"
                color="primary" 
                startIcon={<GoogleIcon />}
                onClick={signInWithGoogle}>
          Sign-Up With Google
        </Button>
        <div>
          Already Have an Account? <Link to="/">Login</Link> now.
        </div>
      </Stack>
    </div> : <LoadingComponent />
  );
};

export default SignUp;